export default function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/selection/each.js
// module id = BRpm
// module chunks = 0